import { sendTrackingEvent } from "../../utils/events";
import { Params } from "../../utils/types";

let prompt_button = <HTMLElement>document.querySelector('.prompt_button');
let prompt_img = <HTMLImageElement>document.querySelector('.prompt_sharpiePack');

export function initPrompt(urlParams: Params) {
    let targetPngSrc = 'https://ddg67ecygv8rc.cloudfront.net/sharpie/' + urlParams.packType + '/' + urlParams.penNum + urlParams.penType + '.png';
    prompt_img.src = targetPngSrc;
}

export function checkIfSkipButtonPressed() {
    return new Promise<void>((resolve, _) => {
        prompt_button.addEventListener("touchend", () => {
            sendTrackingEvent('User tapped SKIP')
            resolve();
        })
    });
}